import React, { Component } from "react"

import {
	CForm,
	CCol,
	CRow,
	CFormInput,
	CFormSelect,
	CFormCheck,
	CButton,
	CInputGroup,
	CInputGroupText,
	CFormLabel,
	CAlert,
} from "@coreui/react"

import { db } from "../../firebase/firebase_config"
import { updateDoc, doc } from "firebase/firestore"

export class UserEditForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			alertVisible: false,
			alertMessage: "",
		}
	}
	async submit_handler(e) {
		console.log("event", e)
		const club = e.target["club"]
		const aletas = e.target["aletas"]
		const stick = e.target["stick"]
		const delanteroCheck = e.target["delanteroCheck"]
		const centroCheck = e.target["centroCheck"]
		const wingCheck = e.target["wingCheck"]
		const porteroCheck = e.target["porteroCheck"]
		const role = e.target["role"]
		const cap = e.target["cap"]
		var position_array = []
		if (delanteroCheck.checked) position_array.push("Delantero")
		if (centroCheck.checked) position_array.push("Centro")
		if (wingCheck.checked) position_array.push("Ala")
		if (porteroCheck.checked) position_array.push("Portero")
		var position_str = position_array.join("/")
		await this.update_db_atributes(
			club.value,
			aletas.value,
			stick.value,
			position_str,
			role.value,
			cap.value
		)
		this.setState({
			alertVisible: true,
			alertMessage: "Succesfully updated profile data!",
		})
		e.preventDefault()
	}

	async update_db_atributes(club, aletas, stick, position, role, cap) {
		try {
			const userRef = doc(db, "Users", this.props.user.uid)
			await updateDoc(userRef, {
				club: club,
				aletas: aletas,
				stick: stick,
				position: position,
				role: role,
				cap: cap,
			})
		} catch (error) {
			console.log(
				"Error resetting dataCLeared flag on firestore data: ",
				error.message
			)
		}
	}

	render() {
		return (
			<CForm className="row g-3" onSubmit={this.submit_handler.bind(this)}>
				<CAlert
					color="success"
					dismissible
					visible={this.state.alertVisible}
					onClose={() => this.setState({ alertVisible: false })}
				>
					{this.state.alertMessage}
				</CAlert>
				<CCol xs={12}>
					<CFormInput id="club" label="Club" placeholder="Mi equipo" required />
				</CCol>
				<CCol md={6}>
					<CFormInput id="stick" label="Stick" required />
				</CCol>

				<CCol md={6}>
					<CFormInput id="aletas" label="Aletas" required />
				</CCol>
				<CInputGroup>
					<CInputGroupText component="label">Posición:</CInputGroupText>
					<CInputGroupText required>
						<CFormCheck
							id="delanteroCheck"
							label="Delantero"
							inline
							variant="outline"
						/>
						<CFormCheck
							id="centroCheck"
							label="Centro"
							inline
							variant="outline"
						/>
						<CFormCheck id="wingCheck" label="Ala" inline variant="outline" />
						<CFormCheck
							id="porteroCheck"
							label="Portero"
							inline
							variant="outline"
						/>
					</CInputGroupText>
				</CInputGroup>

				<CCol md={5}>
					{this.props.user.role === "Administrador" ? (
						<CFormSelect id="role" label="Role" required>
							<option>Jugador</option>
							<option>Entrenador</option>
							<option>Administrador</option>
						</CFormSelect>
					) : (
						<CFormSelect id="role" label="Role" disabled>
							<option>Jugador</option>
							<option>Entrenador</option>
							<option>Administrador</option>
						</CFormSelect>
					)}
				</CCol>

				<CCol md={3}>
					<CFormInput max={99} type="number" id="cap" label="Gorro" required />
				</CCol>

				<CCol xs={12}>
					<CButton type="submit">Aplicar</CButton>
				</CCol>
			</CForm>
		)
	}
}

export default UserEditForm
